module.exports = __webpack_public_path__ + "static/media/pagination-next-all.702a4e88.svg";